import axiosInstance from 'api/axiosInstance'

export const getAnnouncements = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/announcements'
    })
    return data?.data
}

export const createAnnouncement = async (id: number) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/user/announcement/click/${id}`
    })
    return data
}
